import indexedDataEn from 'src/data/faq/en-index.json';
import dataEn from 'src/data/faq/en.json';
import indexedDataId from 'src/data/faq/id-index.json';
import dataId from 'src/data/faq/id.json';
import { useTranslate } from 'src/hooks';

const useHelpAndDocumentationData = () => {
  const { isLangEn } = useTranslate();
  const excludeList = isLangEn
    ? import.meta.env.VITE_FAQ_SUB_CATEGORY_EXCLUDES_EN
    : import.meta.env.VITE_FAQ_SUB_CATEGORY_EXCLUDES_ID;
  const allData = isLangEn ? dataEn : dataId;
  const allIndexedData = isLangEn ? indexedDataEn : indexedDataId;

  const data = allData.map(category => ({
    ...category,
    sub_category: category.sub_category.filter(sub_category => {
      if (!excludeList) return false;
      return !excludeList.split(',').includes(sub_category.name);
    }),
  }));
  const indexedData = allIndexedData.filter(article => {
    if (!excludeList) return false;
    return !excludeList.split(',').includes(article.subCategoryName);
  });

  function findIndexesByTitle(titleToFind: string) {
    const result = indexedData.find(data => data.title === titleToFind);
    return result
      ? {
          categoryIndex: result.categoryIndex,
          subCategoryIndex: result.subCategoryIndex,
          articleIndex: result.articleIndex,
        }
      : null;
  }

  return { data, indexedData, findIndexesByTitle };
};

export default useHelpAndDocumentationData;
